import React from 'react';
import './Hero.css';

function Hero() {
  return (
    <section id="home" className="hero">
      <div className="hero-content">
        <div className="hero-logo">
          <svg width="180" height="180" viewBox="0 0 150 150">
            <circle cx="75" cy="75" r="70" fill="none" stroke="#fff" strokeWidth="3"/>
            <text x="75" y="45" textAnchor="middle" fontSize="11" fill="#fff" fontWeight="600">Napier Indian Advanced</text>
            <text x="75" y="70" textAnchor="middle" fontSize="16" fill="#FFD700" fontWeight="bold">ज्ञा साध्ये</text>
            <text x="75" y="100" textAnchor="middle" fontSize="24" fill="#FFD700" fontWeight="bold">2008</text>
            <text x="75" y="120" textAnchor="middle" fontSize="9" fill="#fff" fontWeight="600">Research Journal of Science</text>
          </svg>
        </div>

        <h1 className="hero-title">Napier Indian Advanced Research Journal of Sciences</h1>
        <p className="hero-subtitle">National Multidisciplinary Peer Reviewed, Referred Half Yearly Research Journal</p>

        <div className="hero-info">
          <div className="info-card">
            <span className="info-label">ISSN</span>
            <span className="info-value">0975-1726</span>
          </div>
          <div className="info-card">
            <span className="info-label">Volume</span>
            <span className="info-value">29</span>
          </div>
          <div className="info-card">
            <span className="info-label">Year</span>
            <span className="info-value">December 2025</span>
          </div>
        </div>

        <div className="hero-buttons">
          <button className="btn btn-primary" onClick={() => document.getElementById('about').scrollIntoView({ behavior: 'smooth' })}>
            Learn More
          </button>
          <button className="btn btn-secondary" onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}>
            Contact Us
          </button>
        </div>
      </div>

      <div className="hero-wave">
        <svg viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path fill="#ffffff" fillOpacity="1" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,154.7C960,171,1056,181,1152,170.7C1248,160,1344,128,1392,112L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
        </svg>
      </div>
    </section>
  );
}

export default Hero;
